<template>
  <span v-if="qualifier === 'Fail'" class="text-red-600 font-semibold">fail</span>
  <span v-else-if="qualifier === 'Softfail'" class="text-orange-600 font-semibold">softfail</span>
  <span v-else-if="qualifier === 'Neutral'" class="text-orange-600 font-semibold">neutral</span>
  <span v-else class="text-green-600 font-semibold">pass</span>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import { Qualifier } from '@/model/Spf';

defineProps({
  qualifier: {
    type: String as PropType<Qualifier>,
    required: true,
  },
});
</script>
